<ul class="tabs" #tabs>
    <ng-content></ng-content>
</ul>
